import { message } from 'antd'

const getFilenameFromResponse = (response, fallbackFilename) => {
  const disposition = response.headers.get('Content-Disposition')
  if (!disposition) return fallbackFilename

  const match = disposition.match(/filename\*=UTF-8''(.+)/)
  if (match && match[1]) {
    return decodeURIComponent(match[1])
  }

  return fallbackFilename
}

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export const downloadImportTemplate = async ({
  service,
  language,
  merchantId,
  t,
  successKey,
  errorKey,
  fallbackFilename = 'report.xlsx'
}) => {
  try {
    const response = await service.downloadImportTemplate(language, merchantId)

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(errorData.message || (errorKey ? t(errorKey) : 'Download template failed'))
    }

    const blob = await response.blob()
    const filename = getFilenameFromResponse(response, fallbackFilename)
    downloadBlob(blob, filename)

    if (successKey) {
      message.success(t(successKey))
    }

    return filename
  } catch (error) {
    console.error('Download template error:', error)
    message.error(error?.message || (errorKey ? t(errorKey) : 'Download template failed'))
    return null
  }
}
